
import actions from './actions';
import reducers from './reducers';

export default {
  actions: actions,
  reducers: reducers
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js